import {SavedFlur} from "./savedFlur";

export class SavedLandregisterfolio{

  constructor() {
    this.flure.push(new SavedFlur())
  }

  id: number;
  number: string;
  gemarkung: string

  flure: Array<SavedFlur> = [];

}
